import { rate } from '@/lib/format';
import { cn } from '@/lib/cn';

interface RateTextProps {
  /** NUMERIC 컬럼이 string 으로 전달될 수도 있어 string 까지 허용 */
  value: number | string | null | undefined;
  digits?: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RateText({ value, digits = 2, size = 'md', className }: RateTextProps) {
  const num =
    value === null || value === undefined || value === ''
      ? null
      : Number(value);
  const isValid = num !== null && Number.isFinite(num);

  const color =
    !isValid || num === 0
      ? 'text-[var(--color-text-sub)]'
      : num > 0
      ? 'text-[var(--color-rise)]'
      : 'text-[var(--color-fall)]';

  const sizeClass =
    size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base font-semibold' : 'text-sm';

  return (
    <span className={cn('num', color, sizeClass, className)}>
      {rate(value, digits)}
    </span>
  );
}
